<template>
    <div
        class="flex flex-row items-center justify-between gap-2 px-1.5"
        :class="{ 'pl-2': props.variant === 'Generic-SSO' || props.variant === 'Developer-Account' }"
    >
        <div class="flex flex-row items-center gap-1.5 min-h-9">
            <div
                v-if="props.variant === 'Koelnmesse-SSO'"
                class="text-white p-1 rounded-xs"
                :class="props.isGrayScale ? 'bg-gray-400' : 'bg-koelnmesse'"
            >
                <KoelnmesseLogo class="h-4" />
            </div>
            <SSOIcon
                v-if="props.variant === 'Generic-SSO'"
                class="size-5 shrink-0"
                :class="props.isGrayScale ? 'text-gray-500' : 'text-yellow-600'"
            />
            <CodeIcon
                v-if="props.variant === 'Developer-Account'"
                class="size-5 shrink-0"
                :class="props.isGrayScale ? 'text-gray-500' : 'text-yellow-600'"
            />

            <h2 :id="props.headlineId" class="text-sm text-gray-700 font-light">
                <slot name="headline" />
            </h2>
            <slot name="icon" />
        </div>

        <slot name="buttons" />
    </div>
</template>

<script setup lang="ts">
import CodeIcon from '../Icon/CodeIcon.vue';
import KoelnmesseLogo from '../Icon/KoelnmesseLogo.vue';
import SSOIcon from '../Icon/SSOIcon.vue';

export type LoginMethodHeaderVariant = 'Koelnmesse-SSO' | 'Generic-SSO' | 'Developer-Account';

type LoginMethodHeaderProps = {
    variant: LoginMethodHeaderVariant;
    headlineId: string;
    isGrayScale: boolean;
};

const props = defineProps<LoginMethodHeaderProps>();
</script>
